"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDefaultPendingClassMetadataCount = getDefaultPendingClassMetadataCount;
function getDefaultPendingClassMetadataCount() {
    return 0;
}
//# sourceMappingURL=getDefaultPendingClassMetadataCount.js.map